"use client";
import { jsx } from "react/jsx-runtime";
import { Dialog } from "@base-ui/react/dialog";
import { Drawer } from "@base-ui/react/drawer";
import { useShouldUseDrawer } from "../../hooks/useShouldUseDrawer.js";
import { DialogModeContext } from "./DialogContext.js";
function DialogRoot({ open, defaultOpen, onOpenChange, onOpenChangeComplete, modal, children }) {
    const useDrawer = useShouldUseDrawer();
    const mode = useDrawer ? 'drawer' : 'dialog';
    return /*#__PURE__*/ jsx(DialogModeContext.Provider, {
        value: mode,
        children: useDrawer ? /*#__PURE__*/ jsx(Drawer.Root, {
            open: open,
            defaultOpen: defaultOpen,
            onOpenChange: onOpenChange,
            onOpenChangeComplete: onOpenChangeComplete,
            modal: modal ?? false,
            children: children
        }) : /*#__PURE__*/ jsx(Dialog.Root, {
            open: open,
            defaultOpen: defaultOpen,
            onOpenChange: onOpenChange,
            onOpenChangeComplete: onOpenChangeComplete,
            modal: modal,
            children: children
        })
    });
}
export { DialogRoot };
